// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2PGgk","footer":"ModalError_footer__1YPYd"};